import { Spreadsheet, getRangeAddress } from '@syncfusion/ej2-spreadsheet';

import { SelectedExcelCellModel } from '../../Models/Excel/SelectedExcelCellModel';
import { CellOriginalBackgroundColor } from '../../Models/Excel/CellOriginalBackgroundColor';

import { ExcelFormatDataService } from '../../DataService/ExcelFormatDataService';
import { ConstantVariables } from '../../Helpers/ConstantVariables';
import { LookupDataService } from '../../DataService/LookupDataService';
import { Select2Helper } from '../../Helpers/Select2Helper';
import { CommonHelper } from '../../Helpers/CommonHelper';
import { ColorHelper } from '../../Helpers/ColorHelper';
import { rgbToHex } from '@syncfusion/ej2/treemap';

export class CreateEnquiryWorkbookManager {

    constructor(private containerElement: JQuery) { }
    
    private spreadsheet : Spreadsheet
    private currentSelectedCellRange : string;

    private currentSelectedCells : SelectedExcelCellModel[] = [];
    private cellOriginalBackgroundColors : CellOriginalBackgroundColor[] = [];

    private formatSelectList : JQuery<HTMLElement>;
    private formatNameInput : JQuery<HTMLElement>;
    private selectedLineFormatBySelectList : JQuery<HTMLElement>;
    private recognitionRowTemplate : JQuery<HTMLElement>;
    private recognitionItemsTable : JQuery<HTMLElement>;
    private addRecognitionItemButton : JQuery<HTMLElement>;
    private customerNameInSheetInput : JQuery<HTMLElement>;
    private selectedSheetInput : JQuery<HTMLElement>;
    private vesselSearchMethodInput : JQuery<HTMLElement>;
    private customerSearchMethodInput : JQuery<HTMLElement>;

    private erpCustomerSelectList : JQuery<HTMLElement>;
    private erpVesselSelectList : JQuery<HTMLElement>;

    private isInitial : boolean;

    public initialize() {
        var self = this;

        var workbookId = self.containerElement.data('workbook-id');

        var loadingContainer = self.containerElement.find('#loading-container');
        var importContainer = self.containerElement.find('#workbook-container');

        self.isInitial = true;
    
        self.spreadsheet = new Spreadsheet( {
            showRibbon: false,
            showAggregate: false,
            showFormulaBar: false,
            allowCellFormatting: true,
            locale: 'en',
            listSeparator: ';',
            selectionSettings: {
                mode: "Single"
            },
            allowEditing: false,
            isProtected: false,
            height: '85vh',
            openUrl: '/api/company/excel/open',
            created: (): void => {
                fetch(`/api/company/excel/${workbookId}/uploadworkbook`) // fetch the remote url
                    .then((response) => {
                        response.blob().then((fileBlob) => { // convert the excel file to blob
                            let file = new File([fileBlob], "Sample.xlsx");
                            self.spreadsheet.open({ file: file }); // open the file into Spreadsheet
                        })
                    })
            },
            openComplete: (args: any) => {
                if(args.response.data == 'NeedPassword' || args.response.data == 'InCorrectPassword') {
                    //spreadsheetElement.removeClass('d-none');
                }
                else if(args.response.data == 'UnsupportedFile') {
                    //spreadsheetElement.removeClass('d-none');
                }
                else {
                    if(this.isInitial && self.formatSelectList.val() != ConstantVariables.EmptyGuid) {
                        self.formatSelectList.trigger('change');
                        self.isInitial = false;
                    }

                    // var activeSheet = self.spreadsheet.getActiveSheet();
                    // if(activeSheet.index != undefined) {
                        
                    //     self.spreadsheet.unprotectSheet(activeSheet.index);
                    // }
                    
                    self.spreadsheet.selectRange('A1:A1');
                    self.currentSelectedCellRange = "A1:A1";

                    setTimeout(() => {
                        self.spreadsheet.freezePanes(0, 0);  
                    }, 250)
   
                    self.selectedSheetInput.val(self.spreadsheet.getActiveSheet().name ?? '');

                    loadingContainer.addClass('d-none');
                    
                }
            },
            select: (args: any) => {
                self.currentSelectedCellRange = args.range;
            }
        });
        self.spreadsheet.appendTo('#workbook-spreadsheet-container');

        
        (<any>window).initializeSaveFormatAndViewEnquiry = () => {
            $('button[form=save-format-and-process-file-form]').prop('disabled', false);
            self.bindEvents();
        }
        

        self.bindEvents();
    }

    private bindEvents() {
        var self = this;

        self.formatSelectList = self.containerElement.find('#excel-format-select-list');
        self.formatNameInput = self.containerElement.find('#excel-format-name-input');
        self.selectedLineFormatBySelectList = self.containerElement.find('#selected-line-format-by-select-list');
        self.recognitionRowTemplate = $('#recognition-point-template');
        self.recognitionItemsTable = $('#recognition-items-table');
        self.addRecognitionItemButton = $('#add-recognition-item-button');
        self.customerNameInSheetInput = self.containerElement.find('#customer-name-in-sheet-input');
        self.erpCustomerSelectList = self.containerElement.find('#erp-customer-select-list');
        self.erpVesselSelectList = self.containerElement.find('#erp-vessel-select-list');
        self.selectedSheetInput = self.containerElement.find('#selected-sheet-input');
        self.vesselSearchMethodInput = self.containerElement.find('#vessel-search-method-input');
        self.customerSearchMethodInput = self.containerElement.find('#customer-search-method-input');

        self.erpCustomerSelectList.off('change').on('change', () => {
            var selectedCustomer = self.erpCustomerSelectList.val();
            if(selectedCustomer == undefined || selectedCustomer == ConstantVariables.EmptyGuid) {
                $('#select2-erp-customer-select-list-container').parent().addClass('is-invalid');
            }
            else {
                $('#select2-erp-customer-select-list-container').parent().removeClass('is-invalid');
            }
        })

        self.erpVesselSelectList.off('change').on('change', () => {
            var selectedVessel = self.erpVesselSelectList.val();

            if(selectedVessel == undefined || selectedVessel == ConstantVariables.EmptyGuid) {
                $('#select2-erp-vessel-select-list-container').parent().addClass('is-invalid');
            }
            else {
                $('#select2-erp-vessel-select-list-container').parent().removeClass('is-invalid');
            }
        })
        
        self.containerElement.find('select.select2').each((index, element) => {
            var selectElement = $(element);
            Select2Helper.BindSelect2Input(selectElement);
        });

        self.containerElement.find('.input-group[data-excel-format-item]').each((index, element) => {
            var formatItem = $(element);
            var excelFormatItemKey = formatItem.data('excel-format-item');
            var formatItemType = formatItem.data('format-item-type');

            var descriptionBackgroundColor = formatItem.find('span').css('background-color');
            //descriptionBackgroundColor = ColorHelper.rgbToHex(descriptionBackgroundColor);

            var columnAndRowInput = formatItem.find('input[data-column-and-row-input]');
            var columnAndRowValueInput = formatItem.find('input[data-column-and-row-value-input]');
            var selectCellButton = formatItem.find('button[data-action="select-cell"]');
            var deselectCellButton = formatItem.find('button[data-action="deselect-cell"]');

            if(columnAndRowInput.val() != '') {
                deselectCellButton.prop('disabled', false);
            }

            selectCellButton.off('click').on('click', () => {
                var cellRange = self.currentSelectedCellRange;
                self.spreadsheet.getData(cellRange).then((cells)=> {
                    var index = 0;

                    cells.forEach((cell, key)=>{
                        if(index == 0) {
                            if(self.selectCell(cellRange, excelFormatItemKey, formatItemType, descriptionBackgroundColor)) {
                                columnAndRowInput.val(cellRange);

                                var cellValue = cell.value;

                                cellValue = cellValue?.replace(/[\r\n]|[^\uD83C-\uDFFFa-zA-Z0-9\!\?\;\:\$\#\@\*\%\,\'\"\<\>\+\(\)\.\-\_]/g, ' ');

                                if(cellValue != undefined) {
                                    columnAndRowValueInput.val(cellValue);
                                    columnAndRowValueInput.attr('title', cellValue);
                                }
                                else {
                                    columnAndRowValueInput.val('');
                                    columnAndRowValueInput.attr('title', '');
                                }

                                if(excelFormatItemKey == 'CustomerName') {
                                    var customerName = cell.value;

                                    self.customerNameInSheetInput.val(customerName ?? '');

                                    if(self.formatNameInput.val() == '') {
                                        var splittedCustomerName = customerName?.split(' ');
                                        if(splittedCustomerName != undefined && splittedCustomerName?.length >= 4) {
                                            customerName = `${splittedCustomerName[0]} ${splittedCustomerName[1]} ${splittedCustomerName[2]} ${splittedCustomerName[3]}`
                                        }
                                        if(customerName != undefined && customerName.length > 2500) {
                                            customerName = customerName.substring(0, 2500);
                                        }
                                        self.formatNameInput.val(customerName ?? '');
                                    }

                                    if(customerName != undefined && customerName.length > 0) {
                                        LookupDataService.searchCustomer(customerName, (searchResult) => {
                                            if(searchResult != undefined && searchResult.erpCustomerId != null && searchResult.resultSearchMethod != null) {
                                                self.erpCustomerSelectList.val(searchResult.erpCustomerId);
                                                self.customerSearchMethodInput.val(searchResult.resultSearchMethod);
                                                $('#select2-erp-customer-select-list-container').parent().removeClass('is-invalid');
                                                self.erpCustomerSelectList.trigger('change');
                                            }
                                        })
                                    }
                                }

                                if(excelFormatItemKey == 'VesselName') {
                                    var vesselName = cell.value;
                                    if(vesselName != undefined && vesselName.length > 0) {
                                        LookupDataService.searchVessel(vesselName, (searchResult) => {
                                            if(searchResult != undefined && searchResult.erpVesselId != null && searchResult.resultSearchMethod != null) {
                                                self.erpVesselSelectList.val(searchResult.erpVesselId);
                                                self.vesselSearchMethodInput.val(searchResult.resultSearchMethod);
                                                $('#select2-erp-vessel-select-list-container').parent().removeClass('is-invalid');
                                                self.erpVesselSelectList.trigger('change');
                                            }
                                        })
                                    }

                                }
                            }
                        }

                        index++;
                    })
                });
            })

            deselectCellButton.off('click').on('click', () => {
                var existingSelectedCellIndex = self.currentSelectedCells.findIndex(x => x.key == excelFormatItemKey );
                if(existingSelectedCellIndex != -1) {
                    self.deselectCell(existingSelectedCellIndex, true)
                }
            })
        })

        if(!self.isInitial) {
            var selectedFormatId = self.formatSelectList.val();
            if(selectedFormatId == undefined || selectedFormatId == ConstantVariables.EmptyGuid) {
                self.formatNameInput.prop('readonly', false);
            }
            else {
                self.formatNameInput.prop('readonly', true);
            }
        }

        self.formatSelectList.off('change').on('change', () => {
            var selectedFormatId = self.formatSelectList.val();
            if(selectedFormatId == undefined || selectedFormatId == ConstantVariables.EmptyGuid) {
                self.formatSelectList.val(ConstantVariables.EmptyGuid);
                self.formatNameInput.val('');
                self.formatNameInput.prop('readonly', false);
                self.recognitionItemsTable.empty();

                self.clearSelectedCells();
            }
            else {
                self.formatNameInput.prop('readonly', true);
                ExcelFormatDataService.getExcelFormatInfo(selectedFormatId.toString(), (formatResult) => {
                    self.clearSelectedCells();
                    self.formatNameInput.val(formatResult.description);
                    self.selectedLineFormatBySelectList.val(formatResult.selectedLineFormatBy);
                    self.recognitionItemsTable.empty();
                    
                    formatResult.formatRecognitionItems.forEach(recognitionItem => {
                        var newRecognitionItem = $(self.recognitionRowTemplate.html());

                        self.bindFormatRecognitionRow(newRecognitionItem);
            
                        var rowInput = newRecognitionItem.find('[data-recognition-column-and-row-input]');
                        rowInput.val(recognitionItem.columnAndRow);
            
                        var rowValueInput = newRecognitionItem.find('[data-recognition-column-and-row-value-input]');
                        rowValueInput.val(recognitionItem.value);

                        self.recognitionItemsTable.append(newRecognitionItem);
                    });

                    var mergedHeadersAndDetails = formatResult.headers.concat(formatResult.details);
                    mergedHeadersAndDetails.forEach(receivedFormatItem => {
                        var inputGroupForKey = self.containerElement.find(`.input-group[data-excel-format-item="${receivedFormatItem.key}"]`);
                        var selectCellButton = inputGroupForKey.find('button[data-action="select-cell"]');
                        
                        if(receivedFormatItem.addressRange != null && receivedFormatItem.addressRange != '') {
                            self.currentSelectedCellRange = receivedFormatItem.addressRange;
                            selectCellButton.trigger('click');
                        }
                    });
                })
            }
        })

        self.recognitionItemsTable.find('.input-group').each((index, element) => {
            var frRow = $(element);
            self.bindFormatRecognitionRow(frRow);
        }) 

        $('button[form=save-format-and-process-file-form]').off('click').on('click', (e) => {
            e.preventDefault();

            self.selectedSheetInput.val(self.spreadsheet.getActiveSheet().name ?? '');

            self.recognitionItemsTable.find('.input-group').each((rowIndex, rowElement) => {
                var row = $(rowElement);
                row.find('[data-set-name]').each((index, nameInput) => {
                    var parsedNameInput = $(nameInput);
                    var nameToSet : string = parsedNameInput.data('set-name').toString();
                    parsedNameInput.prop('name', nameToSet.replace('<I>', `${rowIndex}`))
                })
            })

            self.containerElement.find('form').trigger('submit');
        })

        CommonHelper.bindDisablingSaveButton();

        self.addRecognitionItemButton.off('click').on('click', () => {
            self.addRecognitionPoint(self.currentSelectedCellRange);
        })
    }

    private addRecognitionPoint(selectedCellRange:string) {
        var self = this;
        var cellValue : string | undefined = '';

        self.spreadsheet.getData(selectedCellRange).then((cells) => {
            var index = 0;
            cells.forEach((cell, key)=>{
                if(index == 0) {
                    cellValue = cell.value;
                    //cellValue = cellValue;
                    cellValue = cellValue?.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
                    //cellValue = cellValue?.replace(/[\r\n]|[^\uD83C-\uDFFFa-zA-Z0-9\!\?\;\:\$\#\@\*\%\,\'\"\<\>\+\(\)\.\-\_]/g, ' ');
                }

                index++;
            })
        }).then(() => {
            var newRecognitionItem = $(self.recognitionRowTemplate.html());

            self.bindFormatRecognitionRow(newRecognitionItem);

            var rowInput = newRecognitionItem.find('[data-recognition-column-and-row-input]');
            rowInput.val(selectedCellRange);

            var rowValueInput = newRecognitionItem.find('[data-recognition-column-and-row-value-input]');
            if(cellValue != undefined) {
                rowValueInput.val(cellValue);
            }

            self.recognitionItemsTable.append(newRecognitionItem);
        })
    }
    
    private bindFormatRecognitionRow = (row : JQuery<HTMLElement>) => {
        var deletedButtonInput = row.find('[data-recognition-row-delete-button]');

        deletedButtonInput.off('click').on('click', () => {
            row.remove();
        })
    }


    private selectCell(cellRange:string, formatItemKey:string, formatItemType: string, cellBackgroundColor: string) : boolean {
        var self = this;

        self.spreadsheet.unprotectSheet(self.spreadsheet.getActiveSheet().name);

        var existingSelectedCellForDifferentKeyIndex = self.currentSelectedCells.findIndex(x => x.key != formatItemKey && x.cellRange == cellRange);
        if(existingSelectedCellForDifferentKeyIndex != -1) {
            self.deselectCell(existingSelectedCellForDifferentKeyIndex, true)
        }

        var existingSelectedCellForKeyIndex = self.currentSelectedCells.map(e => e.key).indexOf(formatItemKey);
        if(existingSelectedCellForKeyIndex != -1) {
            self.deselectCell(existingSelectedCellForKeyIndex, false)
        }

        self.spreadsheet.getData(cellRange).then((cells) => {
            var index = 0;
            cells.forEach((cell, key)=>{
                if(index == 0) {
                    var inputGroupForKey = self.containerElement.find(`.input-group[data-excel-format-item="${formatItemKey}"]`);
                    inputGroupForKey.find('button[data-action="deselect-cell"]').prop('disabled', false);

                    var bgColor = cell.style?.backgroundColor;
                    self.cellOriginalBackgroundColors.push( {backgroundColor: bgColor ?? '', cellRange: cellRange});

                    self.currentSelectedCells.push( {key: formatItemKey, cellRange: cellRange});
                    self.spreadsheet.cellFormat({ backgroundColor: `${cellBackgroundColor}` }, cellRange);
                }

                index++;
            })
        })



        return true;
    }

    private deselectCell(selectedCellIndex : number, clearFormInputs : boolean) : boolean {
        var self = this;

        var cellToDeselect = self.currentSelectedCells[selectedCellIndex];

        self.spreadsheet.unprotectSheet(self.spreadsheet.getActiveSheet().name);

        var inputGroupForKey = self.containerElement.find(`.input-group[data-excel-format-item="${cellToDeselect.key}"]`);
        var formatItemType = inputGroupForKey.data('format-item-type');

        var originalBackgroundColor = this.cellOriginalBackgroundColors.find(x => x.cellRange == cellToDeselect.cellRange);
        
        self.spreadsheet.cellFormat({ backgroundColor: originalBackgroundColor != undefined ? originalBackgroundColor.backgroundColor : '' }, cellToDeselect.cellRange);
        self.currentSelectedCells.splice(selectedCellIndex, 1);

        if(clearFormInputs) {

            inputGroupForKey.find('input[data-column-and-row-input]').val('');
            inputGroupForKey.find('input[data-column-and-row-value-input]').val('');
            inputGroupForKey.find('button[data-action="deselect-cell"]').prop('disabled', true);
        }

        return true;
    }

    private clearSelectedCells() {
        var self = this;

        self.spreadsheet.unprotectSheet(self.spreadsheet.getActiveSheet().name);

        self.currentSelectedCells.forEach((cellToClear, index) => {
            var inputGroupForKey = self.containerElement.find(`.input-group[data-excel-format-item="${cellToClear.key}"]`);
            var formatItemType = inputGroupForKey.data('format-item-type');

            var originalBackgroundColor = this.cellOriginalBackgroundColors.find(x => x.cellRange == cellToClear.cellRange);
            self.spreadsheet.cellFormat({ backgroundColor: originalBackgroundColor != undefined ? originalBackgroundColor.backgroundColor : '' }, cellToClear.cellRange);

            inputGroupForKey.find('input[data-column-and-row-input]').val('');
            inputGroupForKey.find('input[data-column-and-row-value-input]').val('');
            inputGroupForKey.find('button[data-action="deselect-cell"]').prop('disabled', true);
        })

        self.currentSelectedCells = [];
    }
}